<template>
	<div class="w-full p-6 print:pt-3 print:pb-0">
		<section>
			<div
				class="section-grid-row grid grid-cols-1 gap-2 *:w-full *:max-w-none print:break-inside-avoid print:pt-0"
			>
				<h2
					class="form-title text-md print:text-secondary-400 pb-2 font-bold print:pb-2 print:text-[11px] print:font-normal print:uppercase"
				>
					{{ t('plan.sectionTitle.jewelryAndAccessories') }}
				</h2>
				<FormKit
					id="accessoriesInstructions"
					name="accessoriesInstructions"
					type="repeater"
					:draggable="false"
					add-button
					:insert-control="true"
					:up-control="false"
					:down-control="false"
				>
					<div
						class="section-grid-row grid grid-cols-2 gap-2 *:w-full *:max-w-none"
					>
						<FormKit
							type="textarea"
							auto-height
							name="item"
							:label="t('plan.accessoriesInstructions.item')"
						/>

						<FormKit
							type="textarea"
							auto-height
							name="returnTo"
							:label="t('plan.accessoriesInstructions.returnTo')"
						/>
					</div>
				</FormKit>
			</div>
		</section>
	</div>
</template>

<script setup lang="ts">
import { usePresentationLocale } from '@/i18n'
import { FormKit } from '@formkit/vue'

const { t } = usePresentationLocale()

defineProps<{
	activePlanIndex: number
}>()
</script>
